import { useEffect } from 'react';

export type Device = 'Windows' | 'iPhone' | 'Android' | 'Mac OS X';

const useApplyMaximumScale = (device: Device, value: number) => {
    useEffect(() => {
        const isDevice = navigator.userAgent.indexOf(device);

        if (isDevice === -1) {
            return;
        }

        const maximumScale = 'maximum-scale=';
        const setMaximumScale = (value: number) => maximumScale + value;

        const metaViewport = document.querySelector('[name=viewport]') as HTMLMetaElement;
        const currentContent = metaViewport?.getAttribute('content');

        const isMaximumScaleAlreadySet = currentContent?.indexOf(maximumScale);

        if (!currentContent) {
            metaViewport.setAttribute('content', setMaximumScale(value));
        } else if (isMaximumScaleAlreadySet && isMaximumScaleAlreadySet !== -1) {
            const newContent = currentContent.replace(
                /maximum-scale=(\d+(\.\d+)?)/,
                setMaximumScale(value)
            );
            metaViewport.setAttribute('content', newContent);
        } else {
            const newContent = currentContent.endsWith(',')
                ? currentContent + maximumScale + 1
                : currentContent + ',' + maximumScale + 1;

            metaViewport.setAttribute('content', newContent);
        }
    }, [device, value]);
};

export default useApplyMaximumScale;
